module.exports = __webpack_public_path__ + "media/src/images/icons/copy/primary-0abdc2a3e4d52272006eb45e6524ba43.svg";